const databaseURL_shared = "https://aste-standalone-seriea.europe-west1.firebasedatabase.app" 
const databaseURL = false; 

const firebaseConfig = {
  apiKey: "AIzaSyAz-lq7zAdWayOQiabbyKekKlh4Utxr0tM",
  authDomain: "asta-live.com",
  databaseURL: databaseURL_shared,
  projectId: "aste-standalone-prod",
  storageBucket: "aste-standalone-prod.appspot.com",
  messagingSenderId: "78234177896",
  appId: "1:78234177896:web:d8004644862efa70de46dd",
  measurementId: "G-8STKKDMTHV"
};

export {
  firebaseConfig,
  databaseURL_shared,
  databaseURL,
}
